import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-gallery.tsx
var LazyCourseGallery = lazy(() => import("./course-gallery-iYbY9DI1.js").then((n) => n.n).then((module) => ({ default: module.CourseGallery })));
function CourseGallery({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-gallery" }),
		children: /* @__PURE__ */ jsx(LazyCourseGallery, { ...props })
	});
}
function CourseGalleryContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-gallery" }),
		children: /* @__PURE__ */ jsx(LazyCourseGallery, { ...props })
	});
}
var useCourseGalleryContent = () => {
	return useMemo(() => ({ courseGallery: { component: CourseGalleryContent } }), []);
};
//#endregion
export { CourseGallery, useCourseGalleryContent };
